import "core-js/modules/es.array.for-each";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { searchgame, searchplatform, searchchannel, searchpkg } from "@/api/dataAll/dataAll";
import { getAll, getsearch, delConsume } from "@/api/financial/consumptionDetails";
import addCdtconversion from "./components/addCdtconversion";
import { SelectType, getconversion, delconversion } from "@/api/aymentsdk/aymentsdk";
import addImportantFile from "./components/addImportantFile";
export default {
  name: "commodityConversion",
  components: {
    addCdtconversion: addCdtconversion,
    addImportantFile: addImportantFile
  },
  data: function data() {
    return {
      minWidth: 200,
      searchgames: [],
      searchplatforms: [],
      searchchannels: [],
      searchpkgs: [],
      pay_types: [],
      gameId: "",
      value1: "",
      value2: [],
      showing: false,
      showFile: false,
      searchData: {
        game: "",
        platform: "",
        channel: "",
        pkg: "",
        pay_mark: ""
      },
      searchMark: {},
      tableData: [],
      addCdtconversion: false,
      total: 0,
      page: 1,
      show: false
    };
  },
  created: function created() {
    var _this = this;

    searchgame().then(function (res) {
      _this.searchgames = res.data;
      _this.gameId = res.data.id;
    });
  },
  methods: {
    gamechange: function gamechange(id) {
      var _this2 = this;

      if (id != "") {
        searchplatform({
          game_id: id
        }).then(function (res) {
          _this2.searchplatforms = res.data;
          _this2.searchData.platform = "";
          _this2.searchData.channel = "";
          _this2.searchData.pkg = "";
          _this2.searchMark.platform = "";
          _this2.searchMark.channel = "";
          _this2.searchMark.pkg = "";
          _this2.searchchannels = [];
          _this2.advchannels = [];
          _this2.advLocation = [];
          _this2.searchpkgs = [];
          _this2.pay_types = [];
          _this2.searchData.pay_mark = "";
          _this2.searchMark.pay_mark = "";

          _this2.searchgames.forEach(function (item) {
            if (item.id == id) {
              _this2.searchMark.game = item.game_mark;
            }
          });
        });
      } else {
        this.searchData.platform = "";
        this.searchData.channel = "";
        this.searchData.pkg = "";
        this.searchMark.pkg = "";
        this.searchMark.platform = "";
        this.searchMark.channel = "";
        this.searchplatforms = [];
        this.searchchannels = [];
        this.searchpkgs = [];
        this.searchMark.game = "";
        this.pay_types = [];
        this.searchData.pay_mark = "";
        this.searchMark.pay_mark = "";
      }
    },
    platformchange: function platformchange(id) {
      var _this3 = this;

      if (id != "") {
        searchchannel({
          platform_id: id
        }).then(function (res) {
          _this3.searchchannels = res.data.channel;
          _this3.pay_types = [];
          _this3.searchData.pay_mark = "";
          _this3.searchMark.pay_mark = "";
          _this3.searchData.channel = "";
          _this3.searchData.pkg = "";
          _this3.searchMark.channel = "";
          _this3.searchMark.pkg = "";
          _this3.searchpkgs = [];

          _this3.searchplatforms.forEach(function (item) {
            if (item.id == id) {
              _this3.searchMark.platform = item.platform_mark;
              _this3.searchData.channel = "";
              _this3.searchMark.channel = "";
            }
          });
        });
      } else {
        this.pay_types = [];
        this.searchData.pay_mark = "";
        this.searchMark.pay_mark = "";
        this.searchData.channel = "";
        this.searchData.pkg = "";
        this.searchMark.channel = "";
        this.searchMark.pkg = "";
        this.searchMark.platform = "";
        this.searchpkgs = [];
        this.searchchannels = [];
      }
    },
    channelchange: function channelchange(id) {
      var _this4 = this;

      if (id != "") {
        this.pay_types = [];
        this.searchData.pay_mark = "";
        this.searchMark.pay_mark = "";
        searchpkg({
          channel_id: id
        }).then(function (res) {
          _this4.searchpkgs = res.data;

          _this4.searchchannels.forEach(function (item) {
            if (item.id == id) {
              _this4.searchMark.channel = item.channel_mark;
              _this4.searchData.pkg = "";
              _this4.searchMark.pkg = "";
            }
          });
        });
      } else {
        this.pay_types = [];
        this.searchData.pay_mark = "";
        this.searchMark.pay_mark = "";
        this.searchData.pkg = "";
        this.searchMark.pkg = "";
        this.searchMark.channel = "";
        this.searchData.channel = "";
        this.searchpkgs = [];
      }
    },
    pkgchange: function pkgchange(id) {
      var _this5 = this;

      if (id != "") {
        this.searchpkgs.forEach(function (item) {
          if (item.id == id) {
            _this5.searchMark.pkg = item.pkg_mark;
          }
        });
        SelectType(this.searchMark).then(function (res) {
          _this5.pay_types = res.data;
        });
      } else {
        this.pay_types = [];
        this.searchData.pay_mark = "";
        this.searchMark.pay_mark = "";
        this.searchMark.pkg = "";
      }
    },
    payTypechange: function payTypechange(id) {
      var _this6 = this;

      if (id != "") {
        this.pay_types.forEach(function (item) {
          if (item.pay_mark == id) {
            _this6.searchMark.pay_mark = item.pay_mark;
          }
        });
      } else {
        this.searchMark.pay_mark = "";
      }
    },
    changeShow: function changeShow(val) {
      this.showing = val;
    },
    changeShowing: function changeShowing(val) {
      this.showFile = val;
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.searchMark.page = val;
      this.searchClick();
    },
    // 批量上传
    importFile: function importFile() {
      this.showFile = true;
      this.showing = true;
    },
    searchClick: function searchClick() {
      var _this7 = this;

      getconversion(this.searchMark).then(function (res) {
        if (res.status == 200) {
          var list = ['game', 'platform', 'channel', 'pkg'];
          _this7.tableData = res.data.data.length ? _this7.$utils.dataConversion(res.data.data, list) : [];
          _this7.total = res.data.total || 0;
          _this7.show = true;
        }
      });
    },
    handleSource: function handleSource(id) {
      this.$refs.addCdtconversion.init(id);
    },
    handleDelete: function handleDelete(id) {
      var _this8 = this;

      this.$confirm("此操作将删除该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                delconversion({
                  id: id
                }).then(function (res) {
                  _this8.searchClick();
                });

                _this8.$message({
                  type: "success",
                  message: "删除成功!"
                });

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      })));
    }
  }
};